"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTemperatureMetric = void 0;
const useClient_1 = require("./useClient");
function useTemperatureMetric() {
    const client = (0, useClient_1.useClient)();
    const activeLocation = client.auth.activeLocation;
    const metricCountries = ["United States", "Liberia", "Myanmar"];
    // check region is set
    if (activeLocation.region === undefined || activeLocation.region === null) {
        throw Error("Unable to set measurement type, location has no region value set");
    }
    if (metricCountries.includes(activeLocation.region)) {
        return "imperial";
    }
    return "metric";
}
exports.useTemperatureMetric = useTemperatureMetric;
//# sourceMappingURL=useTemperatureMetric.js.map